<template>
  <div class="viskase-tile">
    <slot name="content"> </slot>
  </div>
</template>

<script>
export default {
  name: "ViskaseTile",
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.viskase-tile {
  min-height: 60px;
  border: 0px solid #a0273b;
  padding: 3px;
}
</style>
